<template>

    <v-container fluid fill-height>
      <v-layout>
        <v-flex sm8 offset-sm2>
          <v-card>
            <v-chip label class="purple darken-3 white--text">
              {{ channelName }}
            </v-chip>
            <transition-group tag="div" name="list">
                <single-message :message="message" v-for="message in messages" :key="message.id"></single-message>
            </transition-group>
          </v-card>
        </v-flex>
      </v-layout>
      <div class="message_container">
        <div class="centered mb-2">
          <message-form></message-form>
        </div>
      </div>
    </v-container>

</template>

<script>
import MessageForm from './MessageForm'
import SingleMessage from './SingleMessage'
import { mapGetters } from 'vuex'
import firebase from 'firebase'

export default {
  name: 'messages',
  components: { MessageForm, SingleMessage },
  data () {
    return {
      messagesRef: firebase.database().ref('messages'),
      privateMessagesRef: firebase.database().ref('privateMessages'),
      messages: [],
      channel: null,
      listeners: []
    }
  },
  computed: {
    ...mapGetters(['currentChannel', 'currentUser', 'isPrivate']),
    channelName () {
      if (this.channel !== null) {
        return this.isPrivate
          ? '@ ' + this.channel.name
          : '# ' + this.channel.name
      }
    }
  },
  watch: {
    currentChannel () {
      this.detachListeners()

      this.addListeners()

      this.channel = this.currentChannel
    }
  },
  methods: {
    addListeners () {
      let ref = this.getMessageRef()
      ref.child(this.currentChannel.id).on('child_added', snap => {
        let message = snap.val()
        message['id'] = snap.key
        this.messages.push(message)

        this.$nextTick(() => {})
      })
      this.addToListeners(this.currentChannel.id, ref, 'child_added')
    },
    addToListeners (id, ref, event) {
      let index = this.listeners.findIndex(el => {
        return el.id === id && el.ref === ref && el.event === event
      })
      if (index === -1) {
        this.listeners.push({ id: id, ref: ref, event: event })
      }
    },
    detachListeners () {
      this.listeners.forEach(listener => {
        listener.ref.child(listener.id).off(listener.event)
      })

      this.listeners = []
      this.messages = []
    },
    getMessageRef () {
      if (this.isPrivate) {
        return this.privateMessagesRef
      } else {
        return this.messagesRef
      }
    }
  },
  beforeDestroy () {
    this.detachListeners()
  }
}

</script>

<style lang="stylus">
img
  width: 100%
  max-width: 150px
ul
  list-style: none
ul li
  margin: 20px 0
.message_container
  position: fixed
  bottom: 0
  left: 0
  right: 0
  height: 240px
  width: 100%
  padding: 0
  margin: 0
  background: #a7a7a7
  .centered
    position: relative
    width: 100%
    max-width: 600px
    margin-left: auto
    margin-right: auto
    margin-top: 20px
</style>



// WEBPACK FOOTER //
// Messages.vue?5ed960e6